<template>
  <div>
    <div class="model-title">
      <div>
        <router-link to="/model/audit/list"><button class="hollow-btn">返回</button></router-link>
        <button style="width: 100px; margin-left: 30px;" @click="getNextImage">
          下一张
        </button>
        <button style="width: 100px; margin-left: 30px;" @click="getRandomImage" v-if="role === 'reviewer'">
          换一张
        </button>
      </div>
      <div>
        <span v-if="imageId" style="margin-right: 10px">图片ID：{{ imageId }}</span>
        <span v-if="imageId">剩余数量: {{ unfinishedImageCount }}</span>
      </div>
      <!--      <button style="position: absolute; right: 20px; width: 100px" @click="amendOriginImage">-->
      <!--        原图修正-->
      <!--      </button>-->
    </div>
    <div class="anno-content" v-if="imageInfo.url">
      <el-row :gutter="10">
        <el-col :span="10">
          <AnnoPanel
            v-if="imageInfo.url"
            :src="imageInfo.url"
            ref="annopanel"
            :annos="modelAnnos"
            height="646"
            :style="{ height: '646px', background: '#fafafa' }"
            :mode="modelMode"
            scalable
            :separable="true"
            :anno-enable="true"
            maskColor="transparent"
          ></AnnoPanel>
        </el-col>
        <el-col :span="11">
          <AnnoPanel
            v-if="imageInfo.url"
            :src="imageInfo.url"
            ref="annopanel"
            :annos="annos"
            height="646"
            :style="{ height: '646px', background: '#fafafa' }"
            :mode="mode"
            scalable
            :separable="true"
            :anno-enable="true"
            maskColor="transparent"
            @annoClick="annoClick($event)"
          ></AnnoPanel>
        </el-col>
        <el-col :span="2">
          <div class="anno-content">
            <!--            <div class="approve-image">-->
            <!--              <AnnoPanel-->
            <!--                v-if="imageInfo.url"-->
            <!--                :src="imageInfo.url"-->
            <!--                ref="annopanel"-->
            <!--                :annos="annos"-->
            <!--                height="646"-->
            <!--                :style="{ height: '646px', background: '#fafafa' }"-->
            <!--                :mode="mode"-->
            <!--                scalable-->
            <!--                :separable="true"-->
            <!--                :anno-enable="true"-->
            <!--                maskColor="transparent"-->
            <!--                @annoClick="annoClick($event)"-->
            <!--              ></AnnoPanel>-->
            <!--            </div>-->
            <div class="approve-classes anno-option">
              <div
                class="category-option"
                style="text-align: left;"
                v-for="(item, group) of sortedClassifications"
                :key="group"
              >
                <span
                  class="class-option"
                  :class="{ active: currClasses.includes(c.classId), exist: existClasses[c.classId] }"
                  v-for="c of item"
                  :key="c.classId"
                  @click="setClass(0, c.classId)"
                >
                  {{ c.className }}{{ existClasses[c.classId] ? `(${existClasses[c.classId]})` : '' }}
                </span>
                <div class="separate-line"></div>
              </div>
            </div>
            <div style="margin-top: 20px" v-if="role === 'reviewer'">
              <div v-show="mode === 1">
                <button @click="newAnno()" class="submit-button">新增画框</button>
              </div>
              <div v-show="mode === 0" style="display: flex; justify-content: space-around; min-width: 200px">
                <button :disabled="saveAnnoAble" class="submit-button" @click="saveAnno()">
                  保存画框
                </button>
                <button style="background: #c05d5d;" class="submit-button" @click="deleteAnno()">
                  {{ getDeleteName() }}
                </button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import AnnoPanel from '@/components/AnnoPanel';
import * as api from '@/api/api.js';
import ImageDetail from '@/mixins/imagedetail.js';
import { taskTypeMap } from '@/config';

export default {
  name: 'ModelAnno',
  components: {
    AnnoPanel,
  },
  data() {
    return {
      seq: '',
      modelAnnos: [],
      annos: [],
      imageInfo: {},
      imageAnnoModel: [],
      modelMode: 1, // 对应左边模型的mode
      mode: 1,
      cateNameList: [],
      imageTasks: [], // 图片所在任务列表
      pageType: 'amend',
      tasks: [],
      taskId: null,
      unfinishedImageCount: 0,
      hasAnno: true,
    };
  },
  watch: {
    currClasses(newClassId) {
      this.taskId = (this.tasks.find(v => v.classIds.includes(newClassId[0])) || {}).id;
    },
  },
  mixins: [ImageDetail],
  mounted() {
    this.seq = this.$route.params.seq;
    this.getModelTaskImage();
    let _this = this;
    document.onkeydown = function() {
      let key = window.event.keyCode;
      if (key === 27) {
        _this.backToViewMode();
      } else if (key === 81) {
        _this.newAnno();
      }
    };
    this.role = this.$store.state.role;
    this.taskTypeMap = taskTypeMap;
    // this.taskTypeId = 1;
  },
  computed: {
    existClasses() {
      // 管理员页面每个类别要显示属于该类别的标注数量
      let result = {};
      this.orgAnnos
        .reduce((total, item) => [...total, ...item.classIds], [])
        .forEach(v => {
          result[v] = result[v] ? result[v] + 1 : 1;
        });
      return result;
    },
    sortedClassifications() {
      // return this.classifications.map(clf => {
      //   clf.classes = [
      //     ...clf.classes.filter(cls => this.existClasses[cls.classId]),
      //     ...clf.classes.filter(cls => !this.existClasses[cls.classId]),
      //   ];
      //   return clf;
      // });
      return this.classifications.reduce((pre, cur) => {
        cur.classes.forEach(v => {
          const group = parseInt(v.groupId / 100);
          if (pre[group]) {
            pre[group].push(v);
          } else {
            pre[group] = [v];
          }
        });
        return pre;
      }, {});
    },
  },
  methods: {
    getModelTaskImage() {
      api.getModelTaskImage(this.seq, { imgid: this.imageId }).then(res => {
        this.imageInfo = res.data.imageInfo;
        this.imageId = res.data.imageInfo.id;
        this.imageAnnoModel = res.data.imageAnnoModel;
        this.unfinishedImageCount = res.data.unfinishedImageCount;
        this.modelAnnos = res.data.imageAnnoModel.map(v => {
          if (!this.cateNameList.includes(v.categoryName)) {
            this.cateNameList.push(v.categoryName);
          }
          const box = v.box.replace(/\(|\)/g, '').split(',');
          return {
            id: v.id,
            type: 3,
            data: [
              [
                [box[0], box[1]],
                [box[2], box[1]],
                [box[2], box[3]],
                [box[0], box[3]],
              ],
            ],
            cat: this.cateNameList.indexOf(v.categoryName),
            title: v.categoryName,
          };
        });
        this.annotations = res.data.annotations;
        this.height = res.data.imageInfo.height;
        this.width = res.data.imageInfo.width;
        this.tasks = res.data.tasks;
        this.taskTypeId = res.data.tasks.length ? res.data.tasks[0].taskTypeId : 1;
        this.classifications = [
          {
            categoryId: 1,
            categoryName: '安检',
            classes: res.data.classes,
          },
        ];
        this.annosFormat();
        // this.searchImage();
      });
    },
    getNextImage() {
      if (this.role === 'reviewer') {
        api.finishRepairImage(this.seq, this.imageInfo.id).then(() => {
          this.imageInfo = {};
          this.getModelTaskImage();
        });
      } else {
        this.imageInfo = {};
        this.getModelTaskImage();
      }
    },
    getRandomImage() {
      this.imageInfo = {};
      this.getModelTaskImage();
    },
    searchImage() {
      const searchItem = {
        page: 0,
        pagesize: 20,
        customerid: 3,
        mode: 0,
        imageids: this.imageInfo.id,
      };
      api.directlySearch(searchItem).then(res => {
        this.imageTasks = res.data.images;
      });
    },
    amendOriginImage() {
      if (this.imageTasks.length) {
        let query = {
          tid: this.imageTasks[0].taskId,
        };
        Object.assign(query, {
          page: 0,
          pagesize: 20,
          customerid: 3,
          mode: 0,
          imageids: this.imageInfo.id,
        });
        query.f = 's';
        this.$store.commit('setAdminImageList', {
          imageList: this.imageTasks.map(v => {
            return { imageId: v.imageId, taskId: v.taskId };
          }),
        });
        const route = this.$router.resolve({ path: `/image/${this.imageInfo.id}`, query });
        localStorage.setItem('store', JSON.stringify(this.$store.state));
        window.open(route.href, '_blank');
      }
    },
    backToViewMode() {
      if (this.mode === 0) {
        this.mode = 1;
        this.currClasses = [];
        this.sceneText = '';
        this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
      } else {
        if (this.hasAnno) {
          this.annos = [];
          this.hasAnno = false;
        } else {
          this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
          this.hasAnno = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.model-title {
  position: relative;
  margin: 16px 20px;
  display: flex;
  justify-content: space-between;
}
.anno-content {
  height: 646px;
  position: relative;
}
.approve-image {
  box-sizing: border-box;
  margin-right: 224px;
  min-width: 400px;
}
.anno-option {
  /*position: absolute;*/
  /*right: 0px;*/
  /*top: 0px;*/
  width: 200px;
  height: 588px;
  padding-top: 10px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  background: #fafafa;
  overflow: scroll;
}
.class-option {
  display: block;
  cursor: pointer;
  padding: 6px 12px;
  font-size: 14px;
}
.class-option.exist {
  background: rgba(93, 137, 192, 0.15);
}
.class-option.active {
  background: rgba(93, 137, 192, 0.4);
}
.category-option:last-child .separate-line {
  display: none;
}
.separate-line {
  border-top: 1px dashed #bbbbbb;
  margin: 6px;
}
.approve-btn {
  /*position: absolute;*/
  margin-top: 10px;
  right: 0px;
  bottom: 12px;
}
.approve-btn div button:first-child {
  width: 100px;
  margin-right: 40px;
}
.approve-btn div button:last-child {
  width: 60px;
}
.submit-button {
  width: 100px;
  height: 40px;
}
</style>
